import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  OrganizationInventoryRootPage,
  OrganizationInventoryCategorySelectPage,
  OrganizationInventoryResourcePage,
  OrganizationInventoryTrayPage,
  OrganizationInventorySeedPage,
} from './pages';

const InventoryPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  const selectedOrganizationRoot = ROUTES.dashboard.inventory.organization.selected.root;
  const resourceRoot = ROUTES.dashboard.inventory.organization.selected.resource.root;

  return (
    <Switch>
      <Route
        exact
        path={`${path}${selectedOrganizationRoot}`}
        component={OrganizationInventoryCategorySelectPage}
      />
      <Route
        path={`${path}${selectedOrganizationRoot}${resourceRoot}${ROUTES.dashboard.inventory.organization.selected.resource.selected.root}`}
        component={OrganizationInventoryResourcePage}
      />
      <Route
        path={`${path}${selectedOrganizationRoot}${ROUTES.dashboard.inventory.organization.selected.tray.root}`}
        component={OrganizationInventoryTrayPage}
      />
      <Route
        path={`${path}${selectedOrganizationRoot}${ROUTES.dashboard.inventory.organization.selected.seed.root}`}
        component={OrganizationInventorySeedPage}
      />
      <Route
        path={`${path}`}
        component={OrganizationInventoryRootPage}
      />
    </Switch>
  );
};

export default InventoryPage;
